<template>
  <section class="section-two bg-light mt-5 mb-2">
    <div class="container-fluid">
      <div class="row m-3">
        <div class="col-lg-3 mb-4 order-2 order-sm-1 order-md-1">
          <MenuAction/>
        </div>
        <div class="col-lg-9 order-1 order-sm-2 order-md-2">
          <p class="h4">
            <b>Como você deseja agendar?</b>
          </p>
          <div class="card shadow rounded border-0 mb-3 pricing-rates business-rate" @click="selectPaymentType(paymentType)"
               style="cursor: pointer;" v-for="paymentType in paymentTypes">
            <div class="m-3">
              <b class="h6 text-primary">{{paymentType.name}}</b>
              <i class="ms-1 fas fa-1x fa-arrow-circle-right text-primary"></i>
              <p class="text-muted mb-0">{{paymentType.description}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import MenuAction from './MenuAction.vue'

export default {
  name: 'PaymentType',
  components: {
    MenuAction
  },
  data() {
    return {
      search: '',
    }
  },
  computed: {
    schedule() {
      return this.$store.state.toSchedule.schedule;
    },
    paymentTypes() {
      let paymentTypes = this.$store.state.toSchedule.paymentTypes;
      if (this.search === '')
        return paymentTypes;

      return paymentTypes.filter(paymentType => {
        let strFilter = JSON.stringify(paymentType);
        return strFilter.toLowerCase().includes(this.search.toLowerCase())
      });
    },
  },
  mounted() {
    this.$store.dispatch('toSchedule/getPaymentTypes');
  },
  methods: {
    selectPaymentType(paymentType) {
      this.$store.commit('toSchedule/selectPaymentType', paymentType);
      if (paymentType.is_insurance) {
        this.$store.commit('toSchedule/selectPaymentMethod', {
          id_paymeth: paymentType.id_paymeth,
          paymeth_name: 'Convênio',
          paymeth_type: 'CO',
          is_insurance: true,
          additional_information: ''
        });

        this.$router.push('/insurances');
      } else {
        const otherType = this.paymentTypes.find(pt => pt.code !== paymentType.code);
        this.$router.push(`/payment-methods?except=${otherType?.code}`);
      }
    },
  }
}
</script>

<style scoped>

</style>
